import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'tags'
const verb = 'delete'

export default class OspreyTagDelete extends BaseAction {
    constructor() {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425134'
        const path = `/${resource}`
        super(resource, verb, path, id)
        this.noCache = true
    }

    delete(params) {
        const { id } = params

        if (!id) {
            throw new Error('Missing tag id')
        }
        this.path = `/${resource}/${id.value}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/tags/tags-delete.js